import { SetFeatures, FeatureFlagsActionTypes } from './feature-flags.actions';

export interface FeatureFlagsState {
  [featureName: string]: {
    enabled: boolean;
    description: string;
  };
}

export const featureFlagsInitialState: FeatureFlagsState = {};

export function featureFalgsReducer<Form, RowForm>(
  state = featureFlagsInitialState,
  action: SetFeatures,
): FeatureFlagsState {
  if (action.type === FeatureFlagsActionTypes.SetFeatures) {
    return {
      ...state,
      ...action.features.reduce(
        (acc, feature) => ({
          ...acc,
          [feature.name]: {
            enabled: feature.enabled,
            description: feature.description,
          },
        }),
        {},
      ),
    };
  }

  return state;
}
